<template>
  <organization-list></organization-list>
</template>
<script>
import OrganizationList from '../components/List'

export default {
  name: 'organization-view-dashboard',
  components: {
    OrganizationList,
  },
  data() {
    return {
      locationCount: 0,
    }
  },
}
</script>
